import {
	BUSCAR_TODOS_DESTINATARIOS_SUCESSO,
	DESTINATARIOS_MENSAGEM,
	SET_ESTADO_SELECIONADO,
	BUSCAR_DESTINATARIOS_CIDADE_SUCESSO,
	MOSTRAR_LOAD_LISTA_DESTINATARIOS,
	MARCAR_DESTINATARIO_SELECIONADO,
	MARCAR_SELECIONADO_TODOS_DESTINATARIOS,
	DESMARCAR_SELECIONADO_TODOS_DESTINATARIOS,
	ORDER_BY_DEST,
	LINHAS_POR_PAGINA_DEST,
	MUDAR_PAGINA_DEST,
	HABILITAR_ESTADO,
	SET_CIDADE_SELECIONADA,
	SET_DEST_INDEX_SELECIONADOS,
	VERIFICAR_DESTINATARIOS_ASSOCIADOS_SUCESSO,
	VERIFICAR_DESTINATARIOS_ASSOCIADOS_DADOS,
	SET_DEST_STATUS_SUCESSO,
	DESATIVAR_DEST_SEM_ROTA,
	COLUNAS_TABELA_DEST,
	MUDAR_TIPO_DEST_TABELA,
	SET_DEST_TABELA,
	ABRIR_DEST_SELECIONADO,
	BUSCAR_DEST_POR_ESTADO_SUCESSO,
	MUDAR_NIVEL_TABELA_DEST,
	SET_LOADER_LISTA_DESTINATARIOS,
	LIMPAR_TABELA_DEST,
	SET_TIPO_TABELA_DEST
} from 'constants/ActionTypes';
const colunasTabelaDefault = {
	UF: {
		display: true
	},
	Destinatário: {
		display: true
	},
	Endereço: {
		display: true
	},
	Cidade: {
		display: true
	},
	Remetente: {
		display: true
	},
	Situação: {
		display: true
	},
	Bairro: {
		display: true
	}
};
const INIT_STATE = {
	alertMessage: '',
	showMessage: false,
	mensagem: '',
	loader: true,
	loaderListaDestinatarios: false,
	noContentFoundMessage: 'Nenhum destinatário encontrado',
	selectedSectionId: 1,
	filterOption: 'Todos',
	allDestinatarios: [],
	destinatarioList: [],
	selectedRota: null,
	selectedRotas: 0,
	destinosSelecionados: 0,
	addDestinatarioState: false,
	editarDestinatarioState: false,
	selecionarCidade: false,
	mostrarOptionEstado: false,
	order: 'asc',
	orderBy: 'destNome',
	page: 0,
	rowsPerPage: 10,
	destIndexSelecionados: [],
	estadoSelecionado: '',
	cidadeSelecionada: '',
	listaDestinosTabela: [],
	listaDestinos: [],
	allListaDestinos: [],
	estados: [],
	cidades: [],
	destinatariosSemRota: false,
	colunasTabela: { ...colunasTabelaDefault },
	tipoDestTabela: 'cidade',
	nivelTabelaDest: 0,
	tabelaDest: {
		nivel: 0,
		labelNivel: 'Cidade',
		tipo: 'cidade',
		key: '',
		keysLista: []
	}
};

const getRemetentes = (obj) => {
	return Object.keys(obj).map((key) => {
		return {
			nome_dist: obj[key]['nome_dist'],
			cnpj_dist: key
		};
	});
};
export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case BUSCAR_TODOS_DESTINATARIOS_SUCESSO: {
			const destinatarios = action.payload;
			const estados = Object.keys(destinatarios);
			return {
				...state,
				loader: false,
				estados,
				allDestinatarios: destinatarios,
				destinatarioList: destinatarios
			};
		}
		case DESTINATARIOS_MENSAGEM: {
			return {
				...state,
				showMessage: true,
				mensagem: action.payload
			};
		}
		case HABILITAR_ESTADO: {
			return {
				...state,
				mostrarOptionEstado: true
			};
		}
		case SET_CIDADE_SELECIONADA: {
			const { label, value } = action.payload;
			return {
				...state,
				cidadeSelecionada: { label, value }
			};
		}
		case SET_ESTADO_SELECIONADO: {
			const { allDestinatarios } = state;
			const estadoSelecionado = action.payload;
			const cidades = allDestinatarios[estadoSelecionado.value];
			const selecionarCidade = !!cidades;
			return {
				...state,
				selecionarCidade,
				estadoSelecionado,
				cidades
			};
		}
		case BUSCAR_DESTINATARIOS_CIDADE_SUCESSO: {
			let listaDestinosTabela = action.payload;
			listaDestinosTabela = listaDestinosTabela.sort((a, b) => (a[state.orderBy] < b[state.orderBy] ? -1 : 1));
			return {
				...state,
				destIndexSelecionados: [],
				listaDestinosTabela,
				destinosSelecionados: 0,
				loaderListaDestinatarios: false
			};
		}
		case BUSCAR_DEST_POR_ESTADO_SUCESSO: {
			let destinatarios = action.payload;
			return {
				...state,
				destIndexSelecionados: [],
				destinatarios,
				destinosSelecionados: 0,
				loaderListaDestinatarios: false
			};
		}
		case MOSTRAR_LOAD_LISTA_DESTINATARIOS: {
			return {
				...state,
				loaderListaDestinatarios: true
			};
		}
		case ORDER_BY_DEST: {
			const { orderBy, order } = action.payload;
			const listaDestinosTabela = state.listaDestinosTabela.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
			return {
				...state,
				orderBy,
				order,
				listaDestinosTabela
			};
		}
		case LINHAS_POR_PAGINA_DEST: {
			const { rowsPerPage } = action.payload;
			return {
				...state,
				rowsPerPage
			};
		}
		case SET_DEST_INDEX_SELECIONADOS: {
			return {
				...state,
				destIndexSelecionados: action.payload
			};
		}
		case MUDAR_PAGINA_DEST: {
			const { page } = action.payload;
			return {
				...state,
				page
			};
		}
		case MARCAR_DESTINATARIO_SELECIONADO: {
			return {
				...state,
				destinosSelecionados: action.payload.filter((dest) => (dest.selected ? dest.selected : false)).length,
				listaDestinosTabela: action.payload
			};
		}
		case MARCAR_SELECIONADO_TODOS_DESTINATARIOS: {
			const destinosSelecionados = state.listaDestinosTabela.length;
			const destinatarios = state.listaDestinosTabela.map(
				(dest) =>
					dest
						? {
								...dest,
								selected: true
							}
						: dest
			);
			return {
				...state,
				destinosSelecionados,
				listaDestinosTabela: destinatarios
			};
		}
		case DESMARCAR_SELECIONADO_TODOS_DESTINATARIOS: {
			const destinosSelecionados = 0;
			const destinatarios = state.listaDestinosTabela.map(
				(dest) =>
					dest
						? {
								...dest,
								selected: false
							}
						: dest
			);
			return {
				...state,
				destinosSelecionados,
				listaDestinosTabela: destinatarios
			};
		}
		case VERIFICAR_DESTINATARIOS_ASSOCIADOS_SUCESSO: {
			return {
				...state,
				destinatariosSemRota: false
			};
		}
		case VERIFICAR_DESTINATARIOS_ASSOCIADOS_DADOS: {
			return {
				...state,
				destinatariosSemRota: true,
				listaDestinosTabela: action.payload,
				colunasTabela: { ...colunasTabelaDefault }
			};
		}
		case SET_DEST_STATUS_SUCESSO: {
			const { status, _id } = action.payload;

			const listaDestinosTabela = state.listaDestinosTabela.map(
				(dest) => (dest._id === _id ? { ...dest, status } : dest)
			);

			const destinatariosSemRota =
				state.listaDestinosTabela.filter((dest) => dest.status).length > 0 ? true : false;
			return {
				...state,
				listaDestinosTabela,
				destinatariosSemRota
			};
		}
		case DESATIVAR_DEST_SEM_ROTA: {
			return {
				...state,
				destinatariosSemRota: false
			};
		}
		case COLUNAS_TABELA_DEST: {
			const colunasTabela = {
				...state.colunasTabela,
				[action.payload.changedColumn]: {
					...state.colunasTabela[action.payload.changedColumn],
					display: action.payload.action == 'add' ? true : false
				}
			};
			return {
				...state,
				colunasTabela
			};
		}
		case MUDAR_TIPO_DEST_TABELA: {
			const colunas = { ...state.colunasTabela };
			let colunasTabela = { ...state.colunasTabela };
			const { nivel, tipo, labelNivel } = action.payload;
			let tabelaDest = { ...state.tabelaDest };
			switch (nivel) {
				case 0:
					for (let coluna in colunas) colunas[coluna].display = 'excluded';
					tabelaDest = {
						...state.tabelaDest,
						nivel,
						tipo,
						labelNivel
					};
					colunasTabela = {
						...colunas,
						Cidade: {
							...colunas['Cidade'],
							display: true
						},
						Remetente: {
							...colunas['Remetente'],
							display: true
						}
					};
					break;

				default:
					break;
			}
			return {
				...state,
				tabelaDest,
				colunasTabela
			};
		}
		case SET_DEST_TABELA: {
			const listaDestinosTabela = action.payload;
			return {
				...state,
				listaDestinosTabela
			};
		}
		case SET_LOADER_LISTA_DESTINATARIOS: {
			return {
				...state,
				loaderListaDestinatarios: action.payload.loader
			};
		}
		case LIMPAR_TABELA_DEST: {
			return {
				...state,
				listaDestinosTabela: [],
				destIndexSelecionados: [],
				destinosSelecionados: 0
			};
		}

		case MUDAR_NIVEL_TABELA_DEST: {
			const { nivel, key, labelNivel, keysLista } = action.payload;
			const tabelaDest = {
				...state.tabelaDest,
				nivel,
				key,
				labelNivel,
				keysLista
			};
			return {
				...state,
				tabelaDest
			};
		}
		case SET_TIPO_TABELA_DEST: {
			let colunasTabela = { ...colunasTabelaDefault };
			let colunas = { ...colunasTabelaDefault };
			switch (action.payload.tipo) {
				case 'rota':
					for (let coluna in colunas) colunas[coluna].display = 'excluded';
					colunasTabela = {
						...colunas,
						Cidade: {
							...colunas['Cidade'],
							display: true
						},
						Remetente: {
							...colunas['Remetente'],
							display: true
						}
					};
				case 'dest':
					for (let coluna in colunas) colunas[coluna].display = true;
					colunasTabela = {
						...colunas,
						_id: {
							...colunas['_id'],
							display: 'excluded'
						}
					};
			}

			return {
				...state,
				colunasTabela
			};
		}
		case ABRIR_DEST_SELECIONADO: {
			let listaDestinosTabelaState = action.payload ? action.payload : state.listaDestinosTabela;
			const colunas = { ...state.colunasTabela };
			let colunasTabela = { ...state.colunasTabela };
			let tabelaDest = { ...state.tabelaDest };
			const destinatarios = state.destinatarios;
			const destSelecionado = listaDestinosTabelaState.filter((dest) => dest.selected).shift();
			let keysLista = state.tabelaDest.keysLista;
			let listaDestinosTabela = Array();
			let key = '';
			switch (tabelaDest.nivel) {
				case 0:
					key = state.estadoSelecionado.label;
					keysLista.filter((filtro) => filtro.key === key).length == 0 &&
						keysLista.push({ label: key, key, nivel: 0, tipo: 'estado' });
					for (let coluna in colunas) colunas[coluna].display = 'true';
					tabelaDest = {
						...state.tabelaDest,
						nivel: 1,
						tipo: 'cidade',
						key,
						labelNivel: 'Cidade',
						keysLista
					};
					colunasTabela = {
						...colunas,
						Destinatário: {
							...colunas['Destinatário'],
							display: 'excluded'
						},
						Endereço: {
							...colunas['Endereço'],
							display: 'excluded'
						},
						UF: {
							...colunas['UF'],
							display: 'excluded'
						},
						Bairro: {
							...colunas['Bairro'],
							display: 'excluded'
						},
						Cidade: {
							...colunas['Cidade'],
							display: true
						},
						Remetente: {
							...colunas['Remetente'],
							display: true
						},
						_id: {
							...colunas['_id'],
							display: 'excluded'
						}
					};
					for (let cidade in destinatarios) {
						let obj = destinatarios[cidade];
						listaDestinosTabela.push({
							destCidade: obj.cidade_dest,
							codCidade: cidade,
							status: true,
							selected: false,
							distribuidoras: obj['dist'] ? getRemetentes(obj['dist']) : Array(),
							_id: cidade,
							tipo: 'cidade'
						});
					}
					break;
				case 1:
					key = Object.prototype.hasOwnProperty.call(destSelecionado ? destSelecionado : {}, 'destCidade')
						? destSelecionado._id
						: tabelaDest.keysLista[1].key;
					keysLista.filter((filtro) => filtro.key === key).length == 0 &&
						keysLista.push({ label: destSelecionado.destCidade, key, nivel: 1, tipo: 'cidade' });
					tabelaDest = {
						...state.tabelaDest,
						labelNivel: 'Bairro',
						nivel: 2,
						tipo: 'bairro',
						key: key,
						keysLista
					};
					
					for (let coluna in colunas) colunas[coluna].display = 'true';
					colunasTabela = {
						...colunas,
						Destinatário: {
							...colunas['Destinatário'],
							display: 'excluded'
						},
						Endereço: {
							...colunas['Endereço'],
							display: 'excluded'
						},
						UF: {
							...colunas['UF'],
							display: 'excluded'
						},
						Bairro: {
							...colunas['Bairro'],
							display: true
						},
						Remetente: {
							...colunas['Remetente'],
							display: true
						},
						_id: {
							...colunas['_id'],
							display: 'excluded'
						}
					};
					for (let bairro in destinatarios[key]['bairros']) {
						let obj = destinatarios[key]['bairros'][bairro];
						listaDestinosTabela.push({
							destBairro: bairro,
							destCidade: destinatarios[key].cidade_dest,
							codCidade: keysLista[1].key,
							status: true,
							selected: false,
							distribuidoras: obj['dist'] ? getRemetentes(obj['dist']) : Array(),
							tipo: 'bairro',
							_id: key + bairro
						});
						
					}
					break;
				case 2:
					key = Object.prototype.hasOwnProperty.call(destSelecionado ? destSelecionado : {}, 'destBairro')
						? destSelecionado.destBairro
						: tabelaDest.keysLista[2].key;
					keysLista.filter((filtro) => filtro.key === key).length == 0 &&
						keysLista.push({ label: destSelecionado.destBairro, key, nivel: 2, tipo: 'bairro' });
					tabelaDest = {
						...state.tabelaDest,
						labelNivel: 'Endereço',
						nivel: 3,
						tipo: 'endereco',
						key: key,
						keysLista
					};
					for (let coluna in colunas) colunas[coluna].display = true;
					colunasTabela = {
						...colunas,
						UF: {
							...colunas['UF'],
							display: 'excluded'
						},
						Cidade: {
							...colunas['Cidade'],
							display: 'excluded'
						},
						Bairro: {
							...colunas['Bairro'],
							display: 'excluded'
						},
						_id: {
							...colunas['_id'],
							display: 'excluded'
						}
					};
					for (let index in destinatarios[keysLista[1].key]['bairros'][key]['enderecos']) {
						let obj = destinatarios[keysLista[1].key]['bairros'][key]['enderecos'][index];
						listaDestinosTabela.push({
							destCidade: keysLista[1].key,
							destBairro: keysLista[2].key,
							destEnd: obj['end_dest'],
							destNome: obj['nome_dest'],
							cnpjDest: obj['cnpj_dest'],
							codCidade: keysLista[1].key,
							destUf: '',
							status: typeof obj['status'] == 'boolean' ? obj['status'] : true,
							distribuidoras: obj['dist'] ? getRemetentes(obj['dist']) : Array(),
							numeroDest: obj['numero_dest'] ? obj['numero_dest'] : '',
							selected: false,
							tipo: 'end',
							_id: index
						});
					}
					break;
				default:
					break;
			}

			return {
				...state,
				listaDestinosTabela,
				colunasTabela,
				tabelaDest,
				destIndexSelecionados: [],
				destinosSelecionados: 0
			};
		}

		default:
			return state;
	}
};
